<script setup lang="ts">
const props = defineProps<{
  tags?: string[] | null
  /** Базовый путь ленты с фильтром по тегу ('/news', '/blog') */
  basePath: string
}>()
</script>

<template>
  <ul v-if="props.tags?.length" class="flex flex-wrap gap-2">
    <li v-for="tag in props.tags" :key="tag">
      <NuxtLink
        :to="{ path: props.basePath, query: { tag } }"
        class="inline-block rounded-full bg-neutral-100 px-3 py-1 text-xs text-neutral-600 hover:bg-neutral-200"
      >
        #{{ tag }}
      </NuxtLink>
    </li>
  </ul>
</template>
